import { CitationFormat } from "./store"

export function getCitePageURL(
	citationFormat: CitationFormat,
	publicationId: string,
) {
	return `/citations/${encodeURIComponent(publicationId)}/${citationFormat}`
}
